import Loader from "@/components/Loader/Loader";
import { usePermissions } from "@/hooks/usePermissions";
import { hasAnyPermission } from "@/lib/utils";
import { Navigate } from "react-router-dom";

interface ProtectedRouteProps {
  permission?: string[];
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  permission,
  children,
}) => {
  const { permissions, permissionLoading } = usePermissions();

  if (permissionLoading || permissions === null) {
    return <Loader />;
  }

  const hasAccess = hasAnyPermission(permissions, permission || []);

  if (!hasAccess) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;